import { lazy } from 'react';

export const LazyQesRecoveryPage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--qes-recovery-page" */ './qes-recovery-page'
    ),
);
